import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-package-guard',
  templateUrl: './edit-package-guard.component.html',
  styleUrls: ['./edit-package-guard.component.scss'],
  standalone: false,
})
export class EditPackageGuardComponent {
  @Output() onLeavePage = new EventEmitter<boolean>();
  constructor(public dialogRef: MatDialogRef<EditPackageGuardComponent>) {}

  cancel() {
    this.onLeavePage.emit(false);
    this.dialogRef.close();
  }

  leavePage() {
    this.onLeavePage.emit(true);
    this.dialogRef.close();
  }
}
